import { Modal, Button } from '@hydrodigital/design-system';

export interface IConfirmationModalProps {
	showModal: boolean;
	title: string;
	message?: string;
	oncancel: Function;
	onAccept: Function;
	showWarning?: boolean;
}

export default function ConfirmationModal({
	showModal,
	title,
	message,
	oncancel,
	onAccept,
	showWarning = false,
}: IConfirmationModalProps) {
	return (
		<Modal
			isOpen={showModal}
			onClose={() => {
				oncancel();
			}}
			size="s"
			closeOnOverlayClick={true}
			closeOnEscape={true}
			showCloseButton={false}
		>
			<Modal.Header>
				<div className="flex column items-center">
					<span
						className="mb-2"
						style={{ color: '#232B36', fontSize: '1.2rem', fontWeight: 'bold' }}
					>
						{title}
					</span>
				</div>
			</Modal.Header>

			<Modal.Content>
				<div className="flex column items-center">
					<span className="mb-3" style={{ color: '#74788D', fontSize: '1rem', fontWeight: '600' }}>
						{message}
					</span>
					{showWarning && (
						<div
							className="flex column mb-2"
							style={{
								background: 'rgba(255, 211, 211, 0.5)',
								borderRadius: '1rem',
								padding: '1rem',
								color: '#F46A6A',
							}}
						>
							<b>Warning</b>
							<span>The deleted record cannot be recovered</span>
						</div>
					)}
				</div>
			</Modal.Content>
			<div className="separator mb-2" />

			<Modal.Footer>
				<div className="flex">
					<div className="mr-2">
						<Button
							label="No"
							showIcon={false}
							style={{
								width: '85px',
								height: '40px',
								backgroundColor: '#F7F9FA',
								color: '#434B56',
								border: '1px solid #C4CCD5',
							}}
							onClick={() => oncancel()}
						/>
					</div>
					<Button
						label="Yes"
						showIcon={false}
						style={{
							width: '85px',
							height: '40px',
							backgroundColor: '#00203C',
							color: 'white',
						}}
						onClick={async () => onAccept()}
					/>
				</div>
			</Modal.Footer>
		</Modal>
	);
}
